import styles from "./header.module.css";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/src/ScrollTrigger";
import VideoAlert from "../video-alert";
import DOMPurify from "dompurify";
gsap.registerPlugin(ScrollTrigger);

const Header = ({ language, textData, isMobile }) => {
  const canvasRef = useRef(null);
  const ctnRef = useRef(null);
  const textBox1Ref = useRef(null);
  const textBox2Ref = useRef(null);
  const contenBox1Ref = useRef(null);
  const idRef = useRef(null);
  const potHeaderRef = useRef(null);
  const potHeaderRef2 = useRef(null);
  const potRockerTextRef = useRef(null);
  const potBracketTextRef = useRef(null);
  const laborTextRef = useRef(null);
  const laborVideoRef = useRef(null);
  const watchVideoButtonRef = useRef(null);
  useEffect(() => {
    new VideoAlert({
      havePathElement: `.${styles.watchVideoButton}`,
    });
  }, []);

  useEffect(() => {
    // gsap.to(textBox1Ref.current, {
    //   "--color-offset-2": "50%",
    //   duration: 2,
    // });

    // gsap.to(textBox1Ref.current, {
    //   "--color-offset-3": "100%",
    //   duration: 2,
    // });

    gsap.to(textBox1Ref.current, {
      "--opacity": "1",
      duration: 2,
    });

    gsap.to(canvasRef.current, {
      scale: 1,
      //   opacity: 0.5,
      duration: 3,
    });
  }, []);

  useEffect(() => {
    headerAnimation();
  });

  const headerAnimation = () => {
    const currentFrame = (index) =>
      `https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-animation-1/wbl3-detail-animation-${(
        index + 1
      )
        .toString()
        .padStart(5, "0")}.jpg`;

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    canvas.width = 3840;
    canvas.height = 2160;
    const frameCount = 143;
    const images = [];
    const craneM3 = {
      frame: 40,
    };

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      images.push(img);
    }

    images[craneM3.frame].onload = render;

    function render() {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(images[craneM3.frame], 0, 0);
      console.log(craneM3.frame);
    }

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ctnRef.current,
        start: "top top",
        pin: true,
        end: "600%",
        pinSpacing: false,
        scrub: 1,
      },
    });

    tl.to(craneM3, {
      frame: 50,
      snap: "frame",
      onUpdate: render,
      duration: 3,
    });

    tl.to(
      textBox1Ref.current,
      {
        "--color-offset-1": "100%",
        "--color-offset-2": "200%",
        duration: 4,
      },
      0
    );

    tl.to(
      textBox2Ref.current,
      {
        opacity: 1,
        duration: 3,
      },
      2
    );

    tl.to(
      textBox2Ref.current,
      {
        y: 0,
        "--color-offset-2": "100%",
        duration: 8,
      },
      2
    );

    tl.to(
      textBox2Ref.current,
      {
        opacity: 0,
        duration: 4,
      },
      8
    );

    tl.to(
      watchVideoButtonRef.current,
      {
        display: "none",
        duration: 4,
      },
      8
    );

    tl.fromTo(
      canvasRef.current,
      {
        opacity: 0.5,
      },
      {
        opacity: 0.2,
        duration: 4,
      },
      8
    );

    tl.fromTo(
      idRef.current,
      {
        "--opacity-1": 0,
      },
      {
        "--opacity-1": 0.2,
        duration: 2,
      },
      11
    );

    tl.to(
      idRef.current,
      {
        transform:
          "translateX(calc(-100% - var(--size-effect-id-offset))) translateY(0%)",
        duration: 16,
      },
      11
    );

    tl.to(
      idRef.current,
      {
        "--opacity-1": 1,
        duration: 1,
      },
      13
    );

    tl.to(
      idRef.current,
      {
        "--opacity-1": 0.2,
        "--opacity-2": 1,
        duration: 1,
      },
      18
    );

    tl.to(
      idRef.current,
      {
        transform:
          "translateX(calc(-100% - var(--size-effect-id-offset)))  translateY(calc(-50vh - 100%))",
        opacity: 0,
        duration: 14,
      },
      27
    );

    tl.to(
      potHeaderRef.current,
      {
        opacity: 1,
        duration: 1,
      },
      30
    );

    tl.to(
      potHeaderRef.current,
      {
        "--color-offset-2": "100%",
        y: 0,
        duration: 4,
      },
      30
    );

    tl.to(
      potHeaderRef.current,
      {
        transform: "translateY(var(--wb3-size-effect-offset-y))",
        duration: 4,
      },
      32
    );

    tl.to(
      potHeaderRef.current,
      {
        opacity: 0,
        duration: 2,
      },
      34
    );

    tl.to(
      potHeaderRef2.current,
      {
        opacity: 1,
        duration: 1,
      },
      36
    );

    tl.to(
      potHeaderRef2.current,
      {
        "--color-offset-2": "100%",
        y: 0,
        duration: 4,
      },
      36
    );

    tl.to(
      potHeaderRef2.current,
      {
        transform: "translateY(var(--wb3-size-effect-offset-y))",
        duration: 4,
      },
      38
    );

    tl.to(
      potHeaderRef2.current,
      {
        opacity: 0,
        duration: 2,
      },
      40
    );

    tl.to(
      craneM3,
      {
        frame: 90,
        snap: "frame",
        onUpdate: render,
        duration: 13,
      },
      42
    );

    tl.fromTo(
      canvasRef.current,
      {
        opacity: 0.2,
      },
      {
        opacity: 1,
        duration: 2,
      },
      42
    );

    tl.to(
      potRockerTextRef.current,
      {
        opacity: 1,
        duration: 1,
      },
      46
    );

    tl.to(
      potRockerTextRef.current,
      {
        // "--color-offset-2": "100%",
        y: 0,
        duration: 4,
      },
      46
    );

    tl.to(
      potRockerTextRef.current,
      {
        transform: "translateY(var(--wb3-size-effect-offset-y))",
        opacity: 0,
        duration: 2,
      },
      50
    );

    tl.to(
      potBracketTextRef.current,
      {
        opacity: 1,
        duration: 1,
      },
      51
    );

    tl.to(
      potBracketTextRef.current,
      {
        // "--color-offset-2": "100%",
        y: 0,
        duration: 4,
      },
      51
    );

    tl.to(
      potBracketTextRef.current,
      {
        transform: "translateY(var(--wb3-size-effect-offset-y))",
        opacity: 0,
        duration: 2,
      },
      56
    );

    tl.to(
      craneM3,
      {
        frame: 142,
        snap: "frame",
        onUpdate: render,
        duration: 16,
      },
      54
    );

    tl.to(
      laborTextRef.current,
      {
        opacity: 1,
        duration: 1,
      },
      59
    );

    tl.to(
      laborTextRef.current,
      {
        "--color-offset-2": "100%",
        y: 0,
        duration: 4,
      },
      59
    );

    tl.to(
      laborTextRef.current,
      {
        transform: "translateY(var(--wb3-size-effect-offset-y))",
        opacity: 0,
        duration: 2,
      },
      63
    );

    tl.to(
      canvasRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      70
    );
    tl.to(
      laborVideoRef.current,
      {
        opacity: 1,
        visibility: "visible",
        duration: 1,

        onComplete: () => {
          laborVideoRef.current.play();
          console.log("start");
        },
        onReverseComplete: () => {
          laborVideoRef.current.currentTime = 0;
          laborVideoRef.current.pause();
          console.log(laborVideoRef.current.currentTime);
          console.log("onReverseComplete");
        },
      },
      71
    );
    tl.to(laborTextRef.current, {
      transform: "translateY(var(--wb3-size-effect-offset-y))",
      opacity: 0,
      duration: 6,
    });
  };

  return (
    <div className={styles.ctn} ref={ctnRef}>
      <div className={`${styles.section}`}>
        <div
          className={`${styles.textBox} ${styles.textBox1}`}
          ref={textBox1Ref}
        >
          <div className={styles.largeTitle}>WEEBILL 3</div>

          {language === "cn" ? (
            <h1
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData["text1"]),
              }}
            ></h1>
          ) : (
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData["text1"]),
              }}
            ></h3>
          )}
        </div>

        <div
          className={`${styles.textBox} ${styles.textBox2}`}
          ref={textBox2Ref}
        >
          <h4
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text2"]),
            }}
          ></h4>

          <button
            className={styles.watchVideoButton}
            data-video-src={`https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-tvc-${
              language === "cn" ? "cn" : "en"
            }.mp4`}
            ref={watchVideoButtonRef}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 14.1783V3.82167C5 3.03258 5.87115 2.55437 6.53688 2.97801L14.6742 8.15634C15.2917 8.54929 15.2917 9.45071 14.6742 9.84366L6.53688 15.022C5.87115 15.4456 5 14.9674 5 14.1783Z"
                fill="currentColor"
              />
            </svg>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData["text3"]),
              }}
            ></h5>
          </button>
        </div>

        <div className={styles.id} ref={idRef}>
          <div
            className={`${styles.contenBox1} ${styles.contenBox}`}
            ref={contenBox1Ref}
          >
            <div className={styles.contenTextBox}>
              <h2
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData["text4"]),
                }}
              ></h2>

              <div>
                <h5
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(textData["text5"]),
                  }}
                ></h5>
                <h6>
                  <br />
                </h6>
              </div>
            </div>

            <div className={styles.videoBox}>
              <video
                autoPlay
                loop
                playsInline
                muted
                preload="true"
                src="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-2-1.mp4"
                poster="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-2-1-poster.jpg"
              ></video>
            </div>
          </div>

          <div
            className={`${styles.contenBox2} ${styles.contenBox}`}
            ref={contenBox1Ref}
          >
            <div className={styles.contenTextBox}>
              <h2
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData["text6"]),
                }}
              ></h2>

              <div>
                <h5
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(textData["text7"]),
                  }}
                ></h5>

                <h6
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(textData["text57"]),
                  }}
                ></h6>
              </div>
            </div>

            <div className={styles.videoBox}>
              <video
                autoPlay
                loop
                playsInline
                muted
                preload="true"
                src="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-3-1.mp4"
                poster="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-3-1-poster.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div
          className={`${styles.potHeader} ${styles.textBox}`}
          ref={potHeaderRef}
        >
          <h1
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text58"]),
            }}
          ></h1>
        </div>

        <div
          className={`${styles.potHeader} ${styles.textBox}`}
          ref={potHeaderRef2}
        >
          <h3
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text59"]),
            }}
          ></h3>
        </div>

        <div
          className={`${styles.potRockerText} ${styles.textBox}`}
          ref={potRockerTextRef}
        >
          <h3
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text10"]),
            }}
          ></h3>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text11"]),
            }}
          ></h5>
        </div>

        <div
          className={`${styles.potBracketText} ${styles.textBox}`}
          ref={potBracketTextRef}
        >
          <h3
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text12"]),
            }}
          ></h3>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text13"]),
            }}
          ></h5>
        </div>

        <div
          className={`${styles.laborText} ${styles.textBox}`}
          ref={laborTextRef}
        >
          <h4
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text14"]),
            }}
          ></h4>
          <div className={styles.largeTitle}>40%</div>
        </div>
      </div>
      <video
        // autoPlay
        loop
        playsInline
        muted
        preload="true"
        className={styles.laborVideo}
        ref={laborVideoRef}
        poster="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-4-1-poster.jpg"
        src={`https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-4-1${
          isMobile ? "-m" : ""
        }.mp4`}
      ></video>
      <canvas className={styles.headerCanvas} ref={canvasRef}></canvas>
    </div>
  );
};

export default Header;
